import request from '../../config/axiosConfig';
import {
  GET_LIST_SERVICES, GET_SERVICE_INFO, CREATE_SERVICE,
  UPDATE_SERVICE, DELETE_SERVICE, LIST_ACTIVE_SERVICES, LIST_ALL_ACTIVE_SERVICES
} from '../../constants/apiEndPoint';

export const getListServicesRequest = async (data) => {
  const result = await request({ url: GET_LIST_SERVICES, method: 'POST', data });
  return result?.data.data;
};

export const getServiceInfoRequest = async (data) => {
  const result = await request({ url: GET_SERVICE_INFO, method: 'POST', data });
  return result?.data.data;
};

export const createServiceRequest = async (data) => {
  const result = await request({ url: CREATE_SERVICE, method: 'POST', data });
  return result?.data;
};

export const updateServiceRequest = async (data) => {
  const result = await request({ url: UPDATE_SERVICE, method: 'POST', data });
  return result?.data;
};

export const deleteServiceRequest = async (data) => {
  const result = await request({ url: DELETE_SERVICE, method: 'POST', data });
  return result?.data;
};

export const listActiveServicesRequest = async (data) => {
  const result = await request({ url: LIST_ACTIVE_SERVICES, method: 'POST', data });
  return result?.data.data;
};

export const listAllActiveServicesRequest = async (data) => {
  const result = await request({ url: LIST_ALL_ACTIVE_SERVICES, method: 'POST', data });
  return result?.data.data;
};
